export const toMoney = (amount) => {
    let money = Number(amount).toFixed(2);
    money = "$" + parseFloat(money).toLocaleString();

    return money;
}